import { defaultComponents as selectMenuDefaultComponents } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'

import {
  MaisItensSelectMenuItem,
  MaisItensSelectMenuItemProps,
} from '../../MaisItensSelectMenuItem/MaisItensSelectMenuItem'
import { LotacaoAgendaSelectGrupoCabecalho } from '../cabecalho/LotacaoAgendaSelectGrupoCabecalho'
import {
  isTipoGrupoCabecalho,
  isTipoGrupoVazio,
  LotacaoAgendaSelectFieldItemProps,
  LotacaoAgendaSelectMaxItems,
} from '../model-lotacaoAgendaSelectField'
import { LotacaoAgendaSelectGrupoVazioItem } from './LotacaoAgendaSelectGrupoVazioItem'

interface LotacaoAgendaSelectComAcessoRapidoItemProps
  extends LotacaoAgendaSelectFieldItemProps,
    MaisItensSelectMenuItemProps {}

export function LotacaoAgendaSelectComAcessoRapidoItem(props: LotacaoAgendaSelectComAcessoRapidoItemProps) {
  const { index, selectMaxItems: selectSize, ...rest } = props

  const { item, renderItem } = rest

  if (isTipoGrupoCabecalho(item)) {
    return <LotacaoAgendaSelectGrupoCabecalho grupoTipo={item} />
  }

  if (isTipoGrupoVazio(item)) {
    return <LotacaoAgendaSelectGrupoVazioItem grupoTipo={item} />
  }

  if (item === LotacaoAgendaSelectMaxItems.RODAPE_MAIS_ITENS) {
    return <MaisItensSelectMenuItem selectMaxItems={selectSize} />
  }

  return (
    <selectMenuDefaultComponents.Item index={index} {...rest}>
      {renderItem(item)}
    </selectMenuDefaultComponents.Item>
  )
}
